import React from 'react';
import {
  LogoFacebook24,
  LogoInstagram24,
  LogoTwitter24,
  LogoYoutube24,
  LogoLinkedin24,
  Location16,
  Email16,
  PhoneFilled16,
} from '@carbon/icons-react';
import { Link, browserHistory } from 'react-router';
import config from 'config';
import { t } from 'components/translation/Translation';
import { withTranslation } from 'react-i18next';
import styles from './footer.module.scss';

const Footer = () => {
  const { pathname } = browserHistory.getCurrentLocation();
  return (
    <footer className={`${styles.container} ${pathname === '/schola-match' && styles.footer_smr}`} id="footerComponent">
      <div className={styles.content} data-testid="footerContainer">
        <div className={styles.logo_navigation}>
          <div className={styles.logo} data-testid="footerLogo">
            <div>
              <img
                src="https://static.schola.com/logos/schola-dark-blue-horizontal.webp"
                alt="Schola®"
                width="205"
                height="72"
                loading="lazy"
              />
            </div>
            <p>Discover · Connect · Enroll · Succeed</p>
          </div>
          <div className={styles.navigation}>
            <div className={styles.link}>
              <h3 className="spacing-mb-16">{t('parent:layout.schools')}</h3>
              <p className="spacing-mb-8">
                <Link href={`${config.adminHost}/`}>{t('parent:layout.claim')}</Link>
              </p>
              <p>
                <Link href="https://learn.schola.com">{t('parent:layout.schoolResources')}</Link>
              </p>
            </div>
            <div className={styles.link}>
              <h3 className="spacing-mb-16">{t('parent:layout.parents')}</h3>
              <p>
                <Link href="https://learn.schola.com">{t('parent:layout.parentResources')}</Link>
              </p>
            </div>

            <div className={styles.link}>
              <h3 className="spacing-mb-16">{t('aboutUs:aboutUs')}</h3>
              <p className="spacing-mb-8">
                <Link to="/about-us">{t('aboutUs:aboutUs')}</Link>
              </p>
              <p className="spacing-mb-8">
                <Link to="https://static.schola.com/ScholaTOSFinal.pdf" target="_blank">
                  {t('parent:layout.termsOfUse')}
                </Link>
              </p>
              <p>
                <Link to="/privacy">{t('parent:layout.privacyPolicy')}</Link>
              </p>
            </div>
            <div className={styles.scout}>
              <img
                src="https://static.schola.com/profile/footer-scout.webp"
                alt="Schola Scout"
                width="154"
                height="269"
                loading="lazy"
              />
            </div>
          </div>
        </div>
        <div className={styles.schola_info}>
          <div className={styles.schola_address}>
            <div className={styles.info}>
              <Location16 />
              <p>Phoenix, Arizona</p>
            </div>
            <div className={styles.info}>
              <Email16 />
              <p>contactus@schola.com</p>
            </div>
            <div className={styles.info}>
              <PhoneFilled16 />
              <p>(833) 583 1568</p>
            </div>
          </div>
          <div className={styles.social_copy}>
            <div className={styles.social}>
              <Link
                aria-label="Link to Schola Facebook"
                href="https://www.facebook.com/schola.io"
                target="_blank"
                rel="noopener noreferrer">
                <LogoFacebook24 className="spacing-mr-24" />
              </Link>
              <Link
                aria-label="Link to Schola Instagram"
                href="https://www.instagram.com/schola.io"
                target="_blank"
                rel="noopener noreferrer">
                <LogoInstagram24 className="spacing-mr-24" />
              </Link>
              <Link
                aria-label="Link to Schola Twitter"
                href="https://twitter.com/scholaio"
                target="_blank"
                rel="noopener noreferrer">
                <LogoTwitter24 className="spacing-mr-24" />
              </Link>
              <Link
                aria-label="Link to Schola Tiktok"
                href="https://www.tiktok.com/@schola.io"
                target="_blank"
                rel="noopener noreferrer">
                <img
                  className="spacing-mr-24"
                  style={{ marginBottom: '.2rem' }}
                  src="https://static.schola.com/profile/tiktok.webp"
                  alt="Tiktok logo"
                  width="16"
                  height="17"
                />
              </Link>
              <Link
                aria-label="Link to Schola Youtube"
                href="https://www.youtube.com/c/ScholaInc"
                target="_blank"
                rel="noopener noreferrer">
                <LogoYoutube24 className="spacing-mr-24" />
              </Link>
              <Link
                aria-label="Link to Schola linkedin"
                href="https://www.linkedin.com/company/schola-solutions"
                target="_blank"
                rel="noopener noreferrer">
                <LogoLinkedin24 />
              </Link>
            </div>
            <div className={styles.copy}>
              <p>
                © {new Date().getFullYear()} Schola®, Inc. {t('parent:layout.allRightsReserved')}.
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default withTranslation()(Footer);
